import { useState } from 'react'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import { SIZE } from 'baseui/input'
import PropTypes from 'prop-types'
import isValidDate from '@/shared/tools/isValidDate'
import isValidBirthdateAndMoreThan from '@/shared/tools/isValidBirthdate'
import { useTranslation } from 'react-i18next'
import SDMaskedInput from '@/shared/components/SDComponentsNewDesign/SDMaskedInput/SDMaskedInput'
import useBirthdate from './useBirthdate'

const Birthdate = ({
  currentValue,
  error,
  mandatory,
  onChangeHandler,
  setErrors,
  removeErrors,
  disabled,
  missing = false,
}) => {
  const { t } = useTranslation()
  const { inputOverrides } = useBirthdate()
  const currentDate = new Date(currentValue)
  const day = currentValue ? ('0' + currentDate.getDate()).slice(-2) : ''
  const month = currentValue ? ('0' + (currentDate.getMonth() + 1)).slice(-2) : ''
  const display = currentValue ? `${day}/${month}/${currentDate.getFullYear()}` : ''
  const [date, setDate] = useState(display)

  const label = mandatory + t('subscriptionForm:customer_module.birthdate.label')

  const handleChange = birthdate => {
    if (!birthdate || typeof birthdate !== 'string') {
      removeErrors('birthday')
      onChangeHandler(null)
      return
    }
    const value = birthdate.replace(/\s/g, '')
    const [day, month, year] = birthdate.split('/')
    const newDate = new Date(`${month}/${day}/${year} UTC`)
    setDate(birthdate)

    if (value.length === 10) {
      if (isValidDate(newDate) && isValidBirthdateAndMoreThan(newDate, 18)) {
        removeErrors('birthday')
        onChangeHandler(newDate.toISOString().slice(0, 10))
      } else {
        setErrors('birthday', t('subscriptionForm:customer_module.birthdate.error'))
        // tweek to get the error message from backend because it's not a mandatory field
        // if we put empty the backend validation will not apply and remove the front end error
        onChangeHandler('invalid')
      }
    } else if (value.length > 0 && value.length < 10) {
      setErrors('birthday', t('subscriptionForm:customer_module.birthdate.error'))
    } else {
      removeErrors('birthday')
    }
  }

  return (
    <SDFormControl plainLabel error={error}>
      <SDMaskedInput
        label={label}
        disabled={disabled}
        size={SIZE.compact}
        placeholder={t('subscriptionForm:customer_module.birthdate.placeholder')}
        mask='99/99/9999'
        currentValue={date}
        onBlur={handleChange}
        missing={missing}
        overrides={inputOverrides}
      />
    </SDFormControl>
  )
}

Birthdate.propTypes = {
  currentValue: PropTypes.string,
  error: PropTypes.string,
  mandatory: PropTypes.string,
  onChangeHandler: PropTypes.func,
  setErrors: PropTypes.func,
  removeErrors: PropTypes.func,
  disabled: PropTypes.bool,
  missing: PropTypes.bool,
}

export default Birthdate
